<div class="relative min-h-screen flex flex-col">
    <!-- Navbar Start -->
    <app-navbar></app-navbar>
    <!-- Navbar End -->
     
    <div class="flex-grow">
        <!-- To Banner Section Start -->
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[500px] banner-wrapper">
                        <img src="/assets/images/banners/booking-list-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">My Bookings</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- To Banner Section End -->

        <!--Page Content-->
        <div class="container mx-auto mt-4 text-right">
            <div class="custom-margin grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-4">
                <div class="md:col-span-6">
                    <form [formGroup]="searchForm" (ngSubmit)="search()">
                        <!-- Search Box -->
                        <div class="flex flex-wrap space-x-2 items-center">
                            <div class="flex-1">
                                <mat-form-field class="w-full">
                                    <mat-label>Booking Id</mat-label>
                                    <input type="text" matInput placeholder="" formControlName="bookingNo"
                                        [(ngModel)]="bookingNo">
                                </mat-form-field>
                                <div *ngIf="message" class="error-message text-center">
                                    {{ message }}
                                </div>
                            </div>
                            <div class="flex-1">
                                <button type="submit"
                                    class="w-full px-36 md:px-15 sm:px-15 book-now rounded-full borderfont-bold uppercase text-xs py-3 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2">
                                    Search</button>
                                    
                            </div>
                        </div>
                    </form>
                </div>
                <div class="md:col-span-6">
                    <div class="flex items-center justify-center flex-wrap">
                        <button mat-flat-button color="primary" class="reschedule-btn mb-2" (click)="allBookings()">All
                            Bookings</button>
                        <button mat-stroked-button color="primary" class="ml-5 mb-2" (click)="rescheduledBookings()">Re-scheduled
                            Bookings</button>
                        <button mat-flat-button color="primary" class="ml-5 mb-2" (click)="cancelledBookings()">Cancelled
                            Bookings</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="booking-list-wrapper mb-10">
            <div class="container mx-auto">
                <!-- Mat Spinner  -->
                <ngx-spinner bdColor="rgba(256, 256, 256, 0.8)" size="default" color="#6eabc6" type="ball-spin-fade"
                    [fullScreen]="true">
                    <p style="color: black"> Fetching Details... </p>
                </ngx-spinner>
                <div *ngIf="!isCancelled && !isRescheduled  && !errors">
                    <div class="md:custom-margin flex flex-wrap">
                        <div class="w-[450px] h-[490px] mx-auto my-5 pb-[3.5em] booking-list-card relative"
                            *ngFor="let bookingDatas of paginatedParticipantDetails">
                            <div class="image-wrapper">
                                <img src="/assets/images/card-bg.png" alt="">
                            </div>
                            <div class="flex items-center p-[0.5em] justify-center bg-[#f0f2f8] rounded-b-3xl">
                                <div class="w-[35px] h-[35px] mr-5">
                                    <img src="/assets/images/main-icon.png" alt="" class="w-[100%] h-[100%] object-contain">
                                </div>
                                <h2 class="text-base">Booking Details</h2>
                            </div>
                            <h2 class="text-[#677db9] text-sm text-center mt-5 font-normal">Booking No :
                                <span class="text-[#6eabc6]">{{bookingDatas.booking_no}}</span>
                            </h2>
                            <h2 class="text-[#677db9] text-sm text-center mt-2 mb-5 font-normal">Patient Name :
                                <span class="text-[#6eabc6]">{{bookingDatas.patient[0]?.name}}</span>
                            </h2>
                            <div class="flex justify-between px-3">
                                <div class="icon-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/booking-icon.png" alt="">
                                            </span>
                                            <span>Booked On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.created_at |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/doctor-icon.png" alt="">
                                            </span>
                                            <span>Doctor</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.slot.entity}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/slot-icon.png" alt="">
                                            </span>
                                            <span>Slot On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold mb-0 ml-[2.3em]">
                                            {{bookingDatas.slot.start_time |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div class="vertical-line"></div>
                                </div>
                                <div class="icon-second-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/email-icon.png" alt="">
                                            </span>
                                            <span>Email</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.email}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/phone-icon.png" alt="">
                                            </span>
                                            <span>Phone</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.phone}}</p>
                                    </div>
                                    <div class="second-vertical-line"></div>
                                </div>
                            </div>
                            <div class="button-wrapper mt-[3.5em]"
                                *ngIf="!bookingDatas.booking_completely_rescheduled && !bookingDatas.is_cancelled">
                                <button mat-flat-button color="primary" class="gradient-btn"
                                    (click)="applicantBookingDetails(bookingDatas.booking_no)">
                                    <span class="text-white">View Details</span>
                                </button>
                            </div>
                            <p *ngIf="bookingDatas.booking_completely_rescheduled"
                                class=" mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Rescheduled
                            </p>
                            <p *ngIf="bookingDatas.is_cancelled"
                                class="mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Cancelled
                            </p>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5" *ngIf="participantBookingDetails.length > pageSize">
                        <mat-paginator #paginator
                            class="demo-paginator"
                            (page)="handlePageEvent($event)"
                            [length]="length"
                            [pageSize]="pageSize"
                            [disabled]="disabled"
                            [showFirstLastButtons]="showFirstLastButtons"
                            [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
                            [hidePageSize]="hidePageSize"
                            [pageIndex]="pageIndex"
                            aria-label="Select page">
                        </mat-paginator>
                    </div>
                </div>
                <div *ngIf="isCancelled  && !errors">
                    <div class="custom-margin flex flex-wrap">
                        <div class="w-[450px] h-[490px] mx-auto my-5 pb-[3.5em] booking-list-card relative"
                            *ngFor="let bookingDatas of paginatedCancelledDetails">
                            <div class="image-wrapper">
                                <img src="/assets/images/card-bg.png" alt="">
                            </div>
                            <div class="flex items-center p-[0.5em] justify-center bg-[#f0f2f8] rounded-b-3xl">
                                <div class="w-[35px] h-[35px] mr-5">
                                    <img src="/assets/images/main-icon.png" alt="" class="w-[100%] h-[100%] object-contain">
                                </div>
                                <h2 class="text-base">Booking Details</h2>
                            </div>
                            <h2 class="text-[#677db9] text-sm text-center mt-5 font-normal">Booking No :
                                <span class="text-[#6eabc6]">{{bookingDatas.booking_no}}</span>
                            </h2>
                            <h2 class="text-[#677db9] text-sm text-center mt-2 mb-5 font-normal">Patient Name :
                                <span class="text-[#6eabc6]">{{bookingDatas.patient[0]?.name}}</span>
                            </h2>
                            <div class="flex justify-between px-3">
                                <div class="icon-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/booking-icon.png" alt="">
                                            </span>
                                            <span>Booked On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.created_at |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/doctor-icon.png" alt="">
                                            </span>
                                            <span>Doctor</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.slot.entity}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/slot-icon.png" alt="">
                                            </span>
                                            <span>Slot On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold mb-0 ml-[2.3em]">
                                            {{bookingDatas.slot.start_time |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div class="vertical-line"></div>
                                </div>
                                <div class="icon-second-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/email-icon.png" alt="">
                                            </span>
                                            <span>Email</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.email}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/phone-icon.png" alt="">
                                            </span>
                                            <span>Phone</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.phone}}</p>
                                    </div>
                                    <div class="second-vertical-line"></div>
                                </div>
                            </div>
                            <div class="button-wrapper mt-[3.5em]"
                                *ngIf="!bookingDatas.booking_completely_rescheduled && !bookingDatas.is_cancelled">
                                <button mat-flat-button color="primary" class="gradient-btn"
                                    (click)="applicantBookingDetails(bookingDatas.booking_no)">
                                    <span class="text-white">View Details</span>
                                </button>
                            </div>
                            <p *ngIf="bookingDatas.booking_completely_rescheduled"
                                class="mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Rescheduled
                            </p>
                            <p *ngIf="bookingDatas.is_cancelled"
                                class="mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Cancelled
                            </p>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5" *ngIf="allCancelledBookings.length > pageSize">
                        <mat-paginator #paginator
                            class="demo-paginator"
                            (page)="handleCancelPageEvent($event)"
                            [length]="length"
                            [pageSize]="pageSize"
                            [disabled]="disabled"
                            [showFirstLastButtons]="showFirstLastButtons"
                            [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
                            [hidePageSize]="hidePageSize"
                            [pageIndex]="pageIndex"
                            aria-label="Select page">
                        </mat-paginator>
                    </div>
                </div>
                <div *ngIf="isRescheduled  && !errors">
                    <div class="custom-margin flex flex-wrap">
                        <div class="w-[450px] h-[490px] mx-auto my-5 pb-[3.5em] booking-list-card relative"
                            *ngFor="let bookingDatas of paginatedRescheduledDetails">
                            <div class="image-wrapper">
                                <img src="/assets/images/card-bg.png" alt="">
                            </div>
                            <div class="flex items-center p-[0.5em] justify-center bg-[#f0f2f8] rounded-b-3xl">
                                <div class="w-[35px] h-[35px] mr-5">
                                    <img src="/assets/images/main-icon.png" alt="" class="w-[100%] h-[100%] object-contain">
                                </div>
                                <h2 class="text-base">Booking Details</h2>
                            </div>
                            <h2 class="text-[#677db9] text-sm text-center mt-5 font-normal">Booking No :
                                <span class="text-[#6eabc6]">{{bookingDatas.booking_no}}</span>
                            </h2>
                            <h2 class="text-[#677db9] text-sm text-center mt-2 mb-5 font-normal">Patient Name :
                                <span class="text-[#6eabc6]">{{bookingDatas.patient[0]?.name}}</span>
                            </h2>
                            <div class="flex justify-between px-3">
                                <div class="icon-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/booking-icon.png" alt="">
                                            </span>
                                            <span>Booked On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.created_at |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/doctor-icon.png" alt="">
                                            </span>
                                            <span>Doctor</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.slot.entity}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/slot-icon.png" alt="">
                                            </span>
                                            <span>Slot On</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold mb-0 ml-[2.3em]">
                                            {{bookingDatas.slot.start_time |
                                            date:'dd-MMMM-yyyy'}}</p>
                                    </div>
                                    <div class="vertical-line"></div>
                                </div>
                                <div class="icon-second-line-container">
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/email-icon.png" alt="">
                                            </span>
                                            <span>Email</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.email}}</p>
                                    </div>
                                    <div>
                                        <div class="text-xs font-normal text-[#6eabc6]">
                                            <span class="icon-container">
                                                <img src="/assets/images/phone-icon.png" alt="">
                                            </span>
                                            <span>Phone</span>
                                        </div>
                                        <p class="text-[0.75em] font-bold ml-[2.3em]">{{bookingDatas.phone}}</p>
                                    </div>
                                    <div class="second-vertical-line"></div>
                                </div>
                            </div>
                            <div class="button-wrapper"
                                *ngIf="!bookingDatas.booking_completely_rescheduled && !bookingDatas.is_cancelled">
                                <button mat-flat-button color="primary" class="gradient-btn"
                                    (click)="applicantBookingDetails(bookingDatas.booking_no)">
                                    <span class="text-white">View Details</span>
                                </button>
                            </div>
                            <p *ngIf="bookingDatas.booking_completely_rescheduled"
                                class="mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Rescheduled
                            </p>
                            <p *ngIf="bookingDatas.is_cancelled"
                                class="mb-5 ml-auto mr-[1em] text-xs group  text-center w-[100px] text-white py-[0.5em] px-[0.5em] bg-red-700">
                                Cancelled
                            </p>
                        </div>
                    </div>
                    <div class="flex justify-center mt-5" *ngIf="allRescheduledBookings.length > pageSize">
                        <mat-paginator #paginator
                            class="demo-paginator"
                            (page)="handleReschedulePageEvent($event)"
                            [length]="length"
                            [pageSize]="pageSize"
                            [disabled]="disabled"
                            [showFirstLastButtons]="showFirstLastButtons"
                            [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
                            [hidePageSize]="hidePageSize"
                            [pageIndex]="pageIndex"
                            aria-label="Select page">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mx-auto p-10 custom-border flex justify-center items-center mb-[100px]"
            *ngIf="participantBookingDetails.length === 0 && !errors">
            <div class="custom-margin flex justify-center">
                <p class="text-[#667ac3] text-center">
                    "Sorry, but we couldn't find any bookings at the moment. Please consider broadening your search
                    criteria or checking back later. If you have any specific questions or need assistance, feel free to
                    contact our support team. We're here to help!"
                </p>
            </div>
        </div>
        <div class="container mx-auto mb-[4em] p-10 custom-border flex justify-center items-center" *ngIf="errors">
            <div class="custom-margin flex justify-center">
                <p class="text-[#667ac3] text-[1.4em] text-center">
                    {{errors}}
                </p>
            </div>
        </div>
    </div>

    <!-- Footer Start -->
    <app-message></app-message>
    <app-footer></app-footer>
    <!-- Footer End -->
</div>